'use strict';

namespace Core {

    class ScMenubar {

        // Bound
        label: string;

        public element: JQuery;
        public menubarItems: ScMenubarItem[] = [];

        private firstItem: ScMenubarItem;
        private lastItem: ScMenubarItem;

        private backdrop: JQuery;
        private backdropVisible: boolean = false;
        private backdropCloseTimeout: number;
        private backdropCloseDelay: number = 300;

        private eventNamespace: string = 'scmenubar';

        constructor (
            private $scope: ng.IScope,
            private $window: ng.IWindowService,
            private animationUtil: any
        ) {
        }

        public init (element: JQuery): void {
            this.element = element;

            this.firstItem = _.head(this.menubarItems);
            this.lastItem = _.last(this.menubarItems);

            // create a backdrop but don't append it to the DOM
            this.backdrop = $('<div class="sc-o-backdrop sc-o-backdrop--header"></div>');

            this.$scope.$on('$destroy', this.destroy);
        }

        public setFocusToItem (newItem: ScMenubarItem): void {
            newItem.link.focus();
        }

        public setFocusToFirstItem (currentItem): void {
            this.setFocusToItem(this.firstItem);
        }

        public setFocusToLastItem (currentItem): void {
            this.setFocusToItem(this.lastItem);
        }

        public setFocusToNextItem (currentItem: ScMenubarItem): void {
            let nextItem: ScMenubarItem =
                currentItem === this.lastItem
                ? this.firstItem
                : this.menubarItems[this.menubarItems.indexOf(currentItem) + 1];
            this.setFocusToItem(nextItem);
        }

        public setFocusToPreviousItem (currentItem: ScMenubarItem): void {
            let nextItem: ScMenubarItem =
                currentItem === this.firstItem
                ? this.lastItem
                : this.menubarItems[this.menubarItems.indexOf(currentItem) - 1];
            this.setFocusToItem(nextItem);
        }

        public addItem (menubarItem: ScMenubarItem): void {
            // add the item to the array
            this.menubarItems.push(menubarItem);
        }

        public closeMegamenus (): void {
            // close any open megamenus
            _.each(this.menubarItems, (item: ScMenubarItem) => {
                if (item.hasMegamenu && item.megamenu.isOpen) {
                    item.megamenu.close(true);
                }
            });
        }

        public showBackdrop (): void {
            // Cancel any 'hide' request that may not have executed yet.
            clearTimeout(this.backdropCloseTimeout);

            this.backdropVisible = true;

            // append the backdrop to the body
            if (this.backdrop.parent('body').length === 0) {
                this.backdrop.appendTo($('body'));
            }
            // animate the backdrop
            setTimeout(() => this.backdrop.addClass('is-dimmed'));
        }

        public hideBackdrop (animate: boolean): void {

            // Pause before we hide. If we receive another 'show' request then the 'hide' request will be cancelled.
            this.backdropCloseTimeout = setTimeout(() => {
                this.backdropVisible = false;

                if (animate) {
                    // animate backdrop
                    this.backdrop.removeClass('is-dimmed');
                    this.animationUtil.waitForTransition(this.backdrop).then((el) => {
                        // check we still want to remove (a new show request may have been received)
                        !this.backdropVisible && this.backdrop.remove();
                    });

                } else {
                    this.backdrop.remove();
                }

            }, this.backdropCloseDelay);

        }

        private destroy() {
            this.backdrop && this.backdrop.remove();
        }
    }

    class ScMenubarItem {

        // Bound
        label: string;
        url: string|undefined;
        target: string|undefined;
        trackingPath: string;
        hasMegamenu: boolean;

        public element: JQuery;
        public parentMenubar: ScMenubar;
        public megamenu: ScMegamenu;
        public link: JQuery;

        public hasFocus: boolean = false;
        private hoverTimeout: number;
        private hoverDelay: number = 200;

        private linkEvents = {
            'click': (event) => {
                if (this.$window.TRPCONFIG.IsTouchDevice) {
                    // TOUCH BEHAVIOUR
                    //====================
                    if (this.megamenu && !this.megamenu.isOpen) {
                        event.preventDefault();
                        this.megamenu.open();
                    }
                }
                this.trackNavigation();
            },
            'focus': (event) => {
                this.hasFocus = true;
            },
            'blur': (event) => {
                this.hasFocus = false;
            }
        };

        public itemEvents = {
            'keydown': (event) => {
                if (this.$window.TRPCONFIG.IsTouchDevice) {
                    return;
                }
                let preventDefault = true;

                switch (event.keyCode) {
                    case TR.KeyCode.SPACE:
                    case TR.KeyCode.RETURN:
                        if (this.megamenu && !this.megamenu.isOpen) {
                            this.megamenu.open();
                        }
                        break;
                    case TR.KeyCode.LEFT:
                        this.parentMenubar.setFocusToPreviousItem(this);
                        break;
                    case TR.KeyCode.RIGHT:
                        this.parentMenubar.setFocusToNextItem(this);
                        break;
                    case TR.KeyCode.HOME:
                    case TR.KeyCode.PAGEUP:
                        this.parentMenubar.setFocusToLastItem(this);
                        break;
                    case TR.KeyCode.END:
                    case TR.KeyCode.PAGEDOWN:
                        this.parentMenubar.setFocusToFirstItem(this);
                        break;
                    case TR.KeyCode.ESC:
                        if (this.megamenu && this.megamenu.isOpen) {
                            this.megamenu.close(true);
                        }
                    default:
                }
                if (preventDefault) {
                    event.stopPropagation();
                    event.preventDefault();
                }
            },
            'mouseenter': (event) => {
                if (this.$window.TRPCONFIG.IsTouchDevice || !this.megamenu) {
                    return;
                }
                this.hoverTimeout = setTimeout(() => {
                    this.$scope.$apply(() => this.megamenu.open());
                }, this.hoverDelay);
            },
            'mouseleave': (event) => {
                if (this.$window.TRPCONFIG.IsTouchDevice || !this.megamenu) {
                    return;
                }
                clearTimeout(this.hoverTimeout);
                this.megamenu.close(true);
            }
        };


        constructor (
            private $scope: ng.IScope,
            private $window: ng.IWindowService,
            private analytics: any
        ) {
        }

        public init (element: JQuery, menubar: ScMenubar): void {

            this.element = element;
            this.parentMenubar = menubar;
            this.link = this.element.children('a');

            this.parentMenubar.addItem(this);
        }

        public assignMegamenu (megamenu: ScMegamenu) {
            this.megamenu = megamenu;
        }

        public trackNavigation (): void {
            // Mixpanel link tracking
            let data: any = {};
            _.each(this.trackingPath.split('|'), (item, index) => {
                data[`Depth ${index + 1}`] = item;
            });
            this.analytics.track(
                'mixpanel',
                'NavMenuClick',
                data
            );
        }
    }

    class ScMegamenu {

        // Bound
        menuTitle: string;
        url: string;

        public element: JQuery;
        public parentMenubarItem: ScMenubarItem;
        public parentMenubar: ScMenubar;
        public categories: ScMegamenuCategory[] = [];
        public isOpen: boolean = false;

        private firstCategory: ScMegamenuCategory;
        private lastCategory: ScMegamenuCategory;

        public animating: boolean = false;
        public visible: boolean = false;

        private eventNamespace: string = 'smegamenu';

        constructor (
            private $document: ng.IAugmentedJQuery,
            private $scope: ng.IScope,
            private $rootScope: ng.IRootScopeService,
            private animationUtil: any
        ) {
        }

        init (element: JQuery, menubarItem: ScMenubarItem): void {
            this.element = element;
            this.parentMenubarItem = menubarItem;
            this.parentMenubar = menubarItem.parentMenubar;

            this.parentMenubarItem.assignMegamenu(this);

            this.firstCategory = _.head(this.categories);
            this.lastCategory = _.last(this.categories);

            // Select the first category
            if (this.firstCategory && this.firstCategory.popup) {
                this.firstCategory.popup.open();
            }

            this.$rootScope.$on('$routeChangeStart', () => {
                this.shut();
            });
        }

        open (): void {
            if (this.isOpen) {
                return;
            }

            // close any open megamenus
            this.parentMenubar.closeMegamenus();

            this.isOpen = true;

            // animate the backdrop
            this.parentMenubar.showBackdrop();

            // animate the megamenu
            this.animating = true;
            this.visible = true;
            this.animationUtil.waitForTransition(this.element).then((el) => {
                this.animating = false;

                this.$document.on(`mousedown.${this.eventNamespace}`, (e) => {
                    if ($(e.target).closest(this.parentMenubarItem.element).length === 0) {
                        //console.log('close on doc click');
                        this.close(true);
                    }
                });
            });
        }

        close (animate: boolean): void {
            if (!this.isOpen) {
                return;
            }

            this.isOpen = false;

            if (animate) {
                // animate backdrop
                this.parentMenubar.hideBackdrop(true);

                // animate mega menu
                this.animating = true;
                this.visible = false;
                this.animationUtil.waitForTransition(this.element).then((el) => {
                    this.animating = false;
                });

            } else {
                // remove backdrop and hide without animating
                this.parentMenubar.hideBackdrop(false);
                this.visible = false;
            }

            this.$document.off(`.${this.eventNamespace}`);
        }

        public shut(): void {
            this.close(false);
        }

        addCategory (category: ScMegamenuCategory): void {
            // add the item to the array
            this.categories.push(category);
        }
    }

    class ScMegamenuCategory {

        // Bound
        label: string;

        public element: JQuery;
        public parentMegamenu: ScMegamenu;
        public popup: ScMegamenuCategoryPanel;
        public link: JQuery;

        public hasFocus: boolean = false;

        private linkEvents = {
            'click': (event) => {
                if (!this.popup) {
                    return;
                }
                if (this.$window.TRPCONFIG.IsTouchDevice) {
                    // TOUCH BEHAVIOUR
                    //====================
                    this.popup.open();
                }
            },
            'focus': (event) => {
                this.hasFocus = true;
            },
            'blur': (event) => {
                this.hasFocus = false;
            }
        };

        private itemEvents = {
            'mouseenter': (event) => {
                if (this.$window.TRPCONFIG.IsTouchDevice || !this.popup) {
                    return;
                }
                this.popup.open();
            }
        };

        constructor (
            private $window: ng.IWindowService
        ) {
        }

        init (element: JQuery, megamenu: ScMegamenu): void {

            this.element = element;
            this.parentMegamenu = megamenu;
            this.link = this.element.children('a');

            this.link
                .attr('tabIndex', -1);

            this.parentMegamenu.addCategory(this);
        }

        assignPopup (popup: ScMegamenuCategoryPanel) {
            this.popup = popup;
        }
    }

    class ScMegamenuCategoryPanel {

        public element: JQuery;
        public parentCategory: ScMegamenuCategory;
        public isOpen: boolean = false;

        constructor (
        ) {
        }

        init (element: JQuery, megamenuCategory: ScMegamenuCategory): void {
            this.element = element;
            this.parentCategory = megamenuCategory;

            this.parentCategory.assignPopup(this);
        }

        open (): void {
            if (this.isOpen) {
                return;
            }

            // close any other open categories
            _.each(this.parentCategory.parentMegamenu.categories, (category: ScMegamenuCategory) => {
                if (category.popup && category.popup.isOpen) {
                    category.popup.close();
                }
            });

            this.isOpen = true;
        }

        close (): void {
            if (!this.isOpen) {
                return;
            }

            this.isOpen = false;
        }
    }

    class ScMegamenuLink {

        // Bound
        trackingPath: string;

        private element: JQuery;
        private eventNamespace: string = 'scmegamenulink';

        constructor (
            private $scope: ng.IScope,
            private analytics: any
        ) {
        }

        init (element: JQuery): void {
            this.element = element;

            this.element.on(`click.${this.eventNamespace}`, (event) => {
                this.trackNavigation();
            });

            this.$scope.$on('$destroy', this.destroy);
        }

        private trackNavigation (): void {
            // Mixpanel link tracking
            let data: any = {};
            _.each(this.trackingPath.split('|'), (item, index) => {
                data[`Depth ${index + 1}`] = item;
            });
            this.analytics.track(
                'mixpanel',
                'NavMenuClick',
                data
            );
        }

        private destroy(): void {
            this.element.off(`.${this.eventNamespace}`);
        }
    }

    angular
        .module('core')
        .directive('scMenubar', (): ng.IDirective => {
            return {
                scope: {},
                restrict: 'E',
                replace: true,
                transclude: true,
                controller: ScMenubar,
                controllerAs: 'mb',
                bindToController: {
                    label: '@'
                },
                template:
                    `<nav id="main-navigation"
                          class="sc-c-container">
                        <ul class="sc-c-menubar__list"
                            role="menubar"
                            itemscope itemtype="http://www.schema.org/SiteNavigationElement"
                            aria-label="{{mb.label}}"
                            ng-transclude>
                        </ul>
                    </nav>`,
                link: function (
                    scope: ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr,
                    controller: ScMenubar
                ) {
                    controller.init(el);
                }
            };
        })
        .directive('scMenubarItem', (): ng.IDirective => {
            return {
                scope: {},
                restrict: 'E',
                require: '^scMenubar',
                replace: true,
                transclude: true,
                controller: ScMenubarItem,
                controllerAs: 'mbi',
                bindToController: {
                    label: '@',
                    url: '@',
                    target: '@',
                    trackingPath: '@',
                    hasMegamenu: '='
                },
                template:
                    `<li class="sc-c-menubar__item"
                        role="none"
                        ng-mouseenter="mbi.itemEvents.mouseenter($event)"
                        ng-mouseleave="mbi.itemEvents.mouseleave($event)"
                        ng-keydown="mbi.itemEvents.keydown($event)">
                        <a class="sc-c-menubar-link"
                           role="menuitem"
                           ng-attr-tabindex="{{mbi.hasFocus ? '0' : '-1'}}"
                           ng-attr-href="{{mbi.url ? mbi.url : '#'}}"
                           ng-attr-target="{{mbi.target || undefined}}"
                           ng-attr-aria-haspopup="{{mbi.hasMegamenu || undefined}}"
                           ng-attr-aria-expanded="{{mbi.hasMegamenu ? mbi.megamenu.isOpen : undefined}}"
                           ng-click="mbi.linkEvents.click($event)"
                           ng-focus="mbi.linkEvents.focus($event)"
                           ng-blur="mbi.linkEvents.blur($event)">
                           <i ng-if="mbi.hasMegamenu"
                              ng-show="!mbi.megamenu.isOpen"
                              class="sc-c-menubar-link__megamenu-icon icon-chevron-down"></i>
                           <i ng-if="mbi.hasMegamenu"
                              ng-show="mbi.megamenu.isOpen"
                              class="sc-c-menubar-link__megamenu-icon icon-chevron-up"></i>
                            <span>
                              {{mbi.label}}
                            </span>
                        </a>
                    </li>`,
                link: (
                    scope : ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr,
                    menubarCtrl: ScMenubar,
                    transcludeFn
                ) => {
                    scope.mbi.init(el, menubarCtrl);
                    // transclude directly to root element
                    transcludeFn(scope, (contents) => {
                        angular.forEach(contents, (node) => {
                            el.append(node);
                        });
                    });

                    scope.isLinkItem = () => {
                      if (scope.mbi.url) {
                        let linkEl = el.children();
                        let labelEl = linkEl.find('span');

                        linkEl.attr('itemprop', 'url');
                        labelEl.attr('itemprop', 'name');
                      }
                    };
                    scope.isLinkItem();
                }
            };
        })
        .directive('scMegamenu', (): ng.IDirective => {
            return {
                scope: {},
                restrict: 'E',
                require: '^scMenubarItem',
                replace: true,
                transclude: true,
                controller: ScMegamenu,
                controllerAs: 'mm',
                bindToController: {
                    menuTitle: '@',
                    targetSelf: '@',
                    url: '@'
                },
                templateUrl : 'partials/home/directivetemplate?type=ScMegaMenu',
                link: (
                    scope : ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr,
                    menubarItemCtrl: ScMenubarItem
                ) => {
                    scope.mm.init(el, menubarItemCtrl);
                }
            };
        })
        .directive('scMegamenuCategory', (): ng.IDirective => {
            return {
                scope: {},
                restrict: 'E',
                require: '^scMegamenu',
                replace: true,
                transclude: true,
                controller: ScMegamenuCategory,
                controllerAs: 'mmc',
                bindToController: {
                    label: '@'
                },
                template:
                    `<li class="sc-c-megamenu-categories__item"
                         role="none"
                         ng-mouseenter="mmc.itemEvents.mouseenter($event)">
                        <a class="sc-c-megamenu-categories__button" 
                           href="#"
                           role="menuitem"
                           aria-haspopup="true"
                           ng-attr-aria-expanded="{{mmc.popup.isOpen}}"
                           ng-attr-tabindex="{{mmc.hasFocus ? '0' : '-1'}}"
                           ng-click="mmc.linkEvents.click($event)"
                           ng-focus="mmc.linkEvents.focus($event)"
                           ng-blur="mmc.linkEvents.blur($event)">
                            {{mmc.label}}
                        </a>
                        <div class="sc-c-megamenu-category-panel"
                             ng-class="{'open': mmc.popup.isOpen}"
                             ng-transclude>
                        </div>
                    </div>`,
                link: (
                    scope : ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr,
                    megamenuCtrl: ScMegamenu
                ) => {
                    scope.mmc.init(el, megamenuCtrl);
                }
            };
        })
        .directive('scMegamenuCategoryPanel', (): ng.IDirective => {
            return {
                scope: {},
                restrict: 'E',
                require: '^scMegamenuCategory',
                replace: true,
                transclude: true,
                controller: ScMegamenuCategoryPanel,
                controllerAs: 'mmcp',
                template:
                    `<div aria-expanded="{{mmcp.isOpen}}"
                            ng-transclude>
                     </div>`,
                link: (
                    scope : ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr,
                    megamenuCategoryCtrl: ScMegamenuCategory
                ) => {
                    scope.mmcp.init(el, megamenuCategoryCtrl);
                }
            };
        })
        .directive('scMegamenuLink', (): ng.IDirective => {
            return {
                scope: {},
                restrict: 'A',
                controller: ScMegamenuLink,
                controllerAs: 'mml',
                bindToController: {
                    trackingPath: '@'
                },
                link: (
                    scope : ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr,
                    controller: ScMegamenuLink
                ) => {
                    controller.init(el);
                }
            };
        });
}
